<template>
	<div class="flex flex-col gap-8">
		

		<FormGroup :label="$t('forms.asset.asset_properties_form.stage')" :error-text="form.errors?.stage">
			<Dropdown
					v-model="form.stage"
					:options="stageOptions"
					option-label="label"
					option-value="value"
					@change="onStageChange"
					:disabled="isDisabled"
					show-clear
					data-cy="stage-input-option"
			/>
		</FormGroup>

		<FormGroup v-if="form.stage === 'complete'" :label="$t('common.vin')" :error-text="form.errors?.vin">
			<InputText
					v-model="form.vin"
					:placeholder="$t('forms.asset.asset_properties_form.vin_placeholder', { identifier: 'VIN' })"
					maxlength="17"
					@change="onVinChange"
					:disabled="isDisabled"
					data-cy="input-vin-number"
			/>
		</FormGroup>

		<FormGroup v-if="form.stage === 'first_stage'" :label="$t('common.chassis_number')" :error-text="form.errors?.chassis_number">
			<InputText
					v-model="form.chassis_number"
					:placeholder="$t('forms.asset.asset_properties_form.chassis_number_placeholder')"
					@change="onChassisChange"
					:disabled="isDisabled"
					data-cy="input-chassis-number"
			/>
		</FormGroup>

		<FormGroup :label="$t('forms.asset.asset_properties_form.name')" :error-text="form.errors?.name">
			<InputText
					ref="name"
					v-model="form.name"
					:placeholder="$t('common.example', { example: 'AB23XYZ' })"
					@change="form.validate('name')"
					disabled
					data-cy="asset-name-input"
			/>
		</FormGroup>

		<FormGroup :label="$t('forms.asset.asset_properties_form.company')" :error-text="form.errors?.company_id">
			<Dropdown
					v-model="form.company_id"
					:options="companiesStore.getCompanyOptions"
					option-label="name"
					option-value="id"
					@change="form.validate('company_id')"
					:disabled="isDisabled"
					show-clear
					data-cy="asset-company-name"
			/>
		</FormGroup>

		<FormGroup :label="$t('forms.asset.asset_properties_form.asset_type')" :error-text="form.errors?.asset_type_id">
			<Dropdown
				v-model="form.asset_type_id"
				:options="assetTypesStore.getAssetTypeOptions"
				option-label="name"
				option-value="id"
				@change="form.validate('asset_type_id')"
				:disabled="isDisabled"
				show-clear
				:placeholder="$t('forms.common.public')"
				data-cy="asset-type-input-selection"
			/>
		</FormGroup>

	</div>

	<template v-if="hasOnSaveListener || isDeleted">
		<div class="flex justify-end mt-8 space-x-4">
			<Button v-if="hasOnResetListener" link @click="$emit('on-reset', form)" :label="$t('forms.common.reset')" :disabled="form.processing"/>
			<Button data-cy="asset-form-save-button" v-if="hasOnSaveListener && !isDeleted" @click="$emit('on-save', form)" :label="$t('forms.common.save')" :disabled="form.processing"/>
			<Button v-if="isDeleted" @click="$emit('on-recover', form)" :label="$t('forms.common.recover')" :disabled="form.processing" severity="warning" />
		</div>
	</template>
</template>

<script>
import FormGroup from "@/Components/FormGroup.vue";
import { mapStores } from "pinia";
import { useCompaniesStore } from "@/stores/companies.js";
import { useAssetTypesStore } from "@/stores/assetTypes.js";

export default {
	name: "AssetPropertiesForm",
	components: {FormGroup},
	props: {
		form: {
			type: Object,
			required: true,
		},
		isDisabled: {
			type: Boolean,
			default: false,
		},
		isDeleted: {
			type: Boolean,
			default: false,
		}
	},
	computed: {
		...mapStores(
        useCompaniesStore,
        useAssetTypesStore
    ),
		stageOptions() {
			return [
				{ label: this.$t('common.first_stage'), value: 'first_stage' },
				{ label: this.$t('common.complete'), value: 'complete' },
			];
		},
		hasOnSaveListener() {
			return !!(this.$attrs?.onOnSave);
		},
		hasOnResetListener() {
			return !!(this.$attrs?.onOnReset);
		},
	},
	mounted() {
    this.companiesStore.indexCompanyOptions();
    this.assetTypesStore.indexAssetTypeOptions();
		this.$refs.name.$el.focus();
	},
	methods: {
		onStageChange() {
			// Clear identifiers when switching stage to avoid mismatches
			if (this.form.stage === 'complete') {
				if (this.form.vin) this.form.name = this.form.vin;
			} else if (this.form.stage === 'first_stage') {
				this.form.vin = null;
				if (this.form.chassis_number) this.form.name = this.form.chassis_number;
			}
			this.form.validate('stage');
		},
		onVinChange() {
			if (this.form?.vin && this.form.stage === 'complete') {
				this.form.name = this.form.vin;
			}
			this.form.validate('vin');
		},
		onChassisChange() {
			if (this.form?.chassis_number && this.form.stage === 'first_stage') {
				this.form.name = this.form.chassis_number;
			}
			this.form.validate('chassis_number');
		},
	}
}
</script>

<style scoped>

</style>
